export const FETCH_ACCOUNT_CONTENT_STATUS = 'FETCH_ACCOUNT_CONTENT_STATUS';
export const SET_ACCOUNT_CONTENT_STATUS_FETCHING =
  'SET_ACCOUNT_CONTENT_STATUS_FETCHING';
export const REPLACE_ACCOUNT_CONTENT_STATUS = 'REPLACE_ACCOUNT_CONTENT_STATUS';
export const SET_ACCOUNT_CONTENT_STATUS_ERRORED =
  'SET_ACCOUNT_CONTENT_STATUS_ERRORED';
